import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initSentry } from '@/lib/sentry'
import { fehlerPufferInstallieren } from '@/lib/fehlerPuffer'

// Ringpuffer fuer „Problem melden" (Baustein 17) — VOR allem anderen, sonst
// fehlen genau die Fehler beim Laden.
fehlerPufferInstallieren()

// Sentry vor App-Mount — Phase 7a (2026-05-08). Best-effort, blockt nichts.
initSentry().catch(() => { /* no-op */ })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
